"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomNumber = exports.murmurHash3Generator = void 0;
/**
 * Generates a seeded pseudo-random number generator using the MurmurHash3 algorithm.
 * @param seed - The seed for the pseudo-random number generator.
 * @returns A function that generates pseudo-random numbers.
 */
function murmurHash3Generator(seed) {
    // initialize the hash with a constant value XORed with the seed length
    let hash = 1779033703 ^ seed.length;
    for (let i = 0; i < seed.length; i++) {
        // XOR the current hash with the ASCII code of the current character in the seed
        const bitwiseXorFromCharacter = hash ^ seed.charCodeAt(i);
        // multiply the XOR result by a constant prime number
        hash = Math.imul(bitwiseXorFromCharacter, 3432918353);
        // perform a bitwise rotation operation on the hash
        hash = (hash << 13) | (hash >>> 19);
    }
    return () => {
        // return the hash that you can use as a seed
        hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
        hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
        // perform a final bitwise rotation and return the resulting hash
        return (hash ^= hash >>> 16) >>> 0;
    };
}
exports.murmurHash3Generator = murmurHash3Generator;
/**
 * Generates a random number between the specified range.
 *
 * @param max - The maximum value of the range (inclusive).
 * @param min - The minimum value of the range (default: 0).
 * @param seed - An optional seed value to generate a deterministic random number.
 * @returns A function that when called, generates a random number within the specified range.
 */
function randomNumber(max, min = 0, seed) {
    if (min > max) {
        throw new Error('The minimum value must be less than or equal to the maximum value.');
    }
    const generator = seed ? murmurHash3Generator(seed) : Math.random;
    return () => generator() % (max - min + 1) + min;
}
exports.randomNumber = randomNumber;
//# sourceMappingURL=random.util.js.map